import InterfacesSelectDropdownM2OUUIDType from "./InterfaceSelectDropdownM2OUUIDType.vue";
import { defineFieldFormInterface } from "~/entities/field";

export default defineFieldFormInterface({
  type: "uuid",
  interface: "select-dropdown-m2o",
  component: InterfacesSelectDropdownM2OUUIDType,
});

